import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Input, Button, Popconfirm, Typography, message } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { apiUrl } from "../../utility/Connections";

const TableRelationships = ({
    visible,
    onClose,
    evl_relationships,
    handleDeleteRelationship,
    isLinks = false,
    evl_id
}) => {
    const [searchText, setSearchText] = useState("");

    const rootUrl = window.location.origin;

    const filteredData = evl_relationships.filter((item) =>
        Object.values(item).some((val) =>
            String(val).toLowerCase().includes(searchText.toLowerCase())
        )
    );

    const baseColumns = [
        {
            title: "Evaluador",
            children: [
                {
                    title: "Cédula",
                    dataIndex: "evr_evaluator",
                    key: "evr_evaluator",
                },
                {
                    title: "Nombre completo",
                    dataIndex: "evr_evaluator_fullname",
                    key: "evr_evaluator_fullname",
                },
                {
                    title: "Cargo",
                    dataIndex: "evr_evaluator_job_title",
                    key: "evr_evaluator_job_title",
                },
            ]
        },
        {
            title: "Evaluado",
            children: [
                {
                    title: "Cédula",
                    dataIndex: "evr_evaluated",
                    key: "evr_evaluated",
                },
                {
                    title: "Nombre completo",
                    dataIndex: "evr_evaluated_fullname",
                    key: "evr_evaluated_fullname",
                },
                {
                    title: "Cargo",
                    dataIndex: "evr_evaluated_job_title",
                    key: "evr_evaluated_job_title",
                },
            ]
        },
        {
            title: "Tipo de Relación",
            dataIndex: "evr_type",
            key: "evr_type",
        }
    ];

    const actionColumn = {
        title: "Acciones",
        key: "actions",
        align: "center",
        render: (_, record) => (
            <Popconfirm
                title="¿Seguro que deseas eliminar esta relación?"
                onConfirm={() => handleDeleteRelationship(record.evr_uid)}
                okText="Sí"
                cancelText="No"
            >
                <Button danger icon={<DeleteOutlined />} />
            </Popconfirm>
        ),
    }

    const columns = [...baseColumns, actionColumn];

    return (
        <>
            <Input
                placeholder="Buscar por evaluado, evaluador o tipo de relación"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{ marginBottom: 16 }}
                allowClear
            />
            <Table
                className="custom-green-table"
                size="small"
                columns={columns}
                dataSource={filteredData}
                rowKey="evr_uid"
                pagination={{ pageSize: 10, position: ["bottomRight"] }}
                scroll={{ x: "max-content" }}
            />            
        </>
    );
};

export default TableRelationships;
